export default "__VITE_ASSET__CaRN8P6J__"